import { render, staticRenderFns } from "./RuleTemplateList.vue?vue&type=template&id=eb87d774&scoped=true&"
import script from "./RuleTemplateList.vue?vue&type=script&lang=js&"
export * from "./RuleTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./RuleTemplateList.vue?vue&type=style&index=0&id=eb87d774&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb87d774",
  null
  
)

component.options.__file = "RuleTemplateList.vue"
export default component.exports